const ModulesEnum = {
    LOGIN: "login",
    HOME: "home",
    CREAR_CUENTA: "crear_cuenta",
    ORDEN_COMPRA: "orden_compra",
    ORDEN_PAGO: "orden_pago",
    MARCA: "marca",
    UNIDAD: "unidad",
    PRODUCTO: "producto",
    PROVEEDOR: "proveedor",
    CAJA: "caja",
    PROYECTO: "proyecto",
    CENTRO_COSTO: "centro_costo",
    EMPLEEADO: "empleeado",
    ASIGNACION_ITEMS: "asignacion_items",
    TRANSFERENCIA_ITEMS: "transferencia_items",
    INVENTARIO: "inventario",
    USUARIO: "usuario",
    CLIENTE: "cliente",
    PRODUCTO_VENTA: "producto_venta",
    ORDEN_VENTA: "orden_venta",
    ENVIO: "envio",
    MIXER: "mixer",
    VENDEDOR: "vendedor",
    PEDIDO_ITEMS: "pedido_items",
    PROVEEDOR_ORDEN_COMPRA: "proveedor_orden_compra",
    ACCESS: "access",
}

export default ModulesEnum